<template>
  <div style="height: 100%">
    <div class="buttonBox" v-if="showButton">
      <div>
        <div class="chooseButton searchButton" @click="deviceCheckItemInfoEdit('1')"
             v-if="MenuRoleList.indexOf('26')>=0"><i class="el-icon-circle-plus-outline"></i>{{ $t('btn_14') }}
        </div>
        <div class="chooseButton searchButton " @click="deviceCheckItemInfoEdit('2')"
             v-if="MenuRoleList.indexOf('27')>=0"><i class="el-icon-edit-outline"></i>{{ $t('btn_15') }}
        </div>
        <div class="chooseButton searchButton" @click="download"><i class="el-icon-download">{{ $t('btn_12') }}</i>
        </div>
        <div class="chooseButton deleteButton" @click="deleteDocunment"><i
          class="el-icon-delete"></i>{{ $t('btn_16') }}
        </div>
      </div>
    </div>
    <el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableData" highlight-current-row
              @current-change="handleCurrentChangeTree" border
              style="width: 100%;margin:  10px 0 10px 0px" height="79%"
              :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
      <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index"
                       :index="getIndex" width="50">
      </el-table-column>
      <el-table-column prop="name" :label="$t('label_370')" align="center">
        <template slot-scope="scope">
          <p class="tableMiTitle" @click="previewPdf(scope.row)">
            {{ scope.row.name }}<br>
          </p>
        </template>
      </el-table-column>
      <el-table-column prop="type" :label="$t('label_372')" align="center">
        <template slot-scope="scope">
          {{ checkText(scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column prop="realName" :label="$t('label_374')" width="350" align="left"></el-table-column>
      <el-table-column prop="createTime" :label="$t('label_376')" align="center">
        <!--				<template slot-scope="scope">-->
        <!--					{{changeTime(scope.row.createTime)}}-->
        <!--				</template>-->
      </el-table-column>
      <el-table-column prop="createUser" :label="$t('label_378')" align="center">
      </el-table-column>
    </el-table>
    <Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
          @parentMethod="searchPage"></Page>

    <el-dialog v-loading="saveLoading" :title="deviceParamTitle" :visible.sync="dialogDeviceSpot" append-to-body
               :close-on-click-modal='false'
               width="400px" top="15%" :before-close="handleClose" custom-class="dialogBox">
      <div class="dialogBoxMes" style="padding:0 20px;">
        <div class="dialogMes">
          <p><span style="color: #ff0000">*</span>{{ $t('label_370') }}</p>
          <div class="mesInput">
            <el-input v-model="tableDataEdit.name" :disabled="deviceParamTitle==$t('btn_15')"></el-input>
          </div>
        </div>
        <div class="dialogMes">
          <p>{{ $t('label_372') }}</p>
          <div class="mesInput">
            <el-select v-model="tableDataEdit.type" style="width: 210px" filterable :placeholder="$t('input_65')">
              <el-option v-for="(item,index) in checkList" :label="item.val" :value="item.key" :key="item.key">
                <p :v-html="item.val">{{ item.val }}</p>
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="dialogMes">
          <p>{{ $t('label_852') }}</p>
          <div class="mesInput">
            <el-upload class="upload-demo" style="width: 100%;" action="https://jsonplaceholder.typicode.com/posts/"
                       :show-file-list="false" :http-request="upload" accept=".pdf, .jpg, .jpeg, .png, .gif">
              <div class="box"
                   style="background: #43c477;text-align:center;border-radius: 5px;padding: 0 20px;color: #ffffff;cursor: pointer;width: 210px;"
                   :http-request="upload">
                {{ $t('label_852') }}
              </div>
            </el-upload>

          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
				<div class="chooseButton sendButton" @click="tableParamDataEditSave">{{ $t('btn_13') }}</div>
			</span>
    </el-dialog>

    <el-dialog :visible="showPdf == true  || showPicture == true" :show-close="true" :width="'80%'" append-to-body
               class="dialog-div-pre-style"
               :before-close="closePreviewClick" center>
      <div v-if="showPdf == true" class="dialog-body-content-base-style">
        <iframe frameborder="0" :src="$store.getters.getPostUrl+'mes/sysFile/pdf/'+pdfUrl" width='100%' height="600px">
        </iframe>
      </div>
      <div v-else-if="showPicture == true" class="dialog-body-content-base-style">
        <img style="width: 100%;height: 600px;" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+pictureUrl">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import file from "@/assets/js/file/file.js";
import Page from "@/components/common/page";
import utils from '@/utils/utils'

export default {
  name: "maintenanceItem",
  components: {
    Page,
  },
  props: {
    showButton: {
      type: Boolean,
      default: ''
    },
    needSort: {
      type: Boolean,
      default: true
    },
    fatherMethod: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      saveLoading: false,
      versionFlag: 0,
      pageNum: 1,
      pageSize: 10,
      showPdf: false,
      showPicture: false,
      MenuRoleList: [],
      tableDataTreeInfo: {},
      tableDataEdit: {
        changeState: 0,
        equipmentId: '',
        fileId: '',
        name: "",
        type: '',
        pid: 0,
        sort: 0,
        status: 0,
      },
      pageCount: 0,
      deviceParamTitle: this.$t('btn_14'),
      pdfUrl: '',
      pictureUrl: '',
      dialogDeviceSpot: false,
      tableData: [],
      allDeviceData: [],
      checkList: [],
      weekendMesOptions: [{
        value: '0',
        label: this.$t('label_719')
      }, {
        value: '1',
        label: this.$t('label_721')
      }, {
        value: '2',
        label: this.$t('label_723')
      }, {
        value: '3',
        label: this.$t('label_725')
      }, {
        value: '4',
        label: this.$t('label_728')
      }, {
        value: '5',
        label: this.$t('label_730')
      }, {
        value: '6',
        label: this.$t('label_716')
      },],
      monthDOptions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      monthOptions: [this.$t('label_245'), this.$t('label_242'), this.$t('label_238')],
      monthOptionsObj: {
        // this.$t('label_245'): ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
        // this.$t('label_242'): ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
        // this.$t('label_238'): ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
      },
      searchDataList: {
        equipmentId: ''
      },
      deptId: ''
    }
  },
  methods: {
    getIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    changeSelectMonth() {
      this.tableDataEdit.monthD = '';
      for (const k in this.monthOptions) {
        if (this.tableDataEdit.month === this.monthOptions[k]) {
          this.monthDOptions = this.monthOptionsObj[this.tableDataEdit.month]
        }
      }
    },
    newMes(id, versionFlag) {
      this.searchDataList.equipmentId = id;
      if (versionFlag == 1) {
        this.versionFlag = versionFlag;
      }
    },
    handleCurrentChangeTree(info) {
      this.tableDataTreeInfo = info;
      console.log(this.tableDataTreeInfo);
    },
    searchPage(param) {
      let dataParam = this.searchDataList;
      let newParam = Object.assign(param, dataParam);
      this.pageNum = newParam.pageNum;
      this.pageSize = newParam.pageSize;
      this.$refs['pageModel'].setCurrent(this.pageNum);
      if (this.versionFlag == 1) {
        this.getEquipmentDocumentInfo1(newParam)
      } else {
        this.getEquipmentDocumentInfo(newParam)
      }
    },
    search() {
      let param = {
        pageNum: 1,
        pageSize: this.pageSize,
      }
      this.searchPage(param)
    },
    checkText(type) {
      let data = this.checkList.filter(function (item) {
        return item.key == type;
      });
      if (data != '') {
        return data[0].val
      }
    },
    getCheckList() {
      file.getByDictIdALL({dictId: 5, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.checkList = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
      // file.getTxtTypeList().then((response) => {
      // 	const data = response.data;
      // 	if (data.code == "1") {
      // 		this.checkList = data.data;
      // 	}
      // }).catch((response) => {
      // 	console.log(response)
      // })
    },
    handleClose() {
      this.dialogDeviceSpot = false;
      this.tableDataEdit = {
        changeState: 0,
        equipmentId: '',
        fileId: '',
        name: "",
        type: '',
        pid: 0,
        sort: 0,
        status: 0,
      }
    },
    checkTypeText(type) {
      if (type == '1') {
        return this.$t('label_145')
      }
      if (type == '2') {
        return this.$t('label_149')
      }
      if (type == '3') {
        return this.$t('label_141')
      }
      if (type == '4') {
        return this.$t('label_138')
      }
    },
    upload(file1) {
      let formData = new FormData();
      formData.append('file', file1.file);
      formData.append('organizationId', this.deptId);
      file.upload(formData).then((response) => {
        const data = response.data;
        if (data.code == 1) {
          this.tableDataEdit.fileId = data.data
          this.$message({
            message: this.$t('msg_15'),
            type: 'success'
          });
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    getEquipmentDocumentInfo(param) {
      file.getEquipmentDocumentInfo(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.tableData = data.data.records;
          this.pageSize = data.data.size;
          this.pageCount = data.data.total;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    getEquipmentDocumentInfo1(param) {
      file.getEquipmentDocumentInfo1(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.tableData = data.data.records;
          this.pageSize = data.data.size;
          this.pageCount = data.data.total;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    deviceCheckItemInfoEdit(title) {
      if (title == '2') {
        if (Object.keys(this.tableDataTreeInfo).length > 0) {
          file.getEquipmentDocumentMes(this.tableDataTreeInfo.id).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.deviceParamTitle = this.$t('btn_15');
              this.tableDataEdit = data.data;
              this.tableDataEdit.type = this.tableDataEdit.type.toString()
              this.dialogDeviceSpot = true;
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
          }).catch((response) => {
            console.log(response)
          })
        } else {
          utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
        }
      } else {
        this.dialogDeviceSpot = true;
        this.deviceParamTitle = this.$t('btn_14');
      }
    },
    tableParamDataEditSave() {
      this.saveLoading = true;
      if (this.tableDataEdit.name == null || this.tableDataEdit.name == '') {
        utils.messageAlert(this.$t('msg_46'), this.$t('label_358'), this.$t('label_100'));
        this.saveLoading = false;
        return;
      }
      if (this.tableDataEdit.type == null || this.tableDataEdit.type == '') {
        utils.messageAlert(this.$t('msg_218'), this.$t('label_358'), this.$t('label_100'));
        this.saveLoading = false;
        return;
      }
      if (this.tableDataEdit.fileId == null || this.tableDataEdit.fileId == '') {
        utils.messageAlert(this.$t('msg_111'), this.$t('label_358'), this.$t('label_100'));
        this.saveLoading = false;
        return;
      }
      if (this.deviceParamTitle == this.$t('btn_14')) {
        this.tableDataEdit.sort = this.pageCount + 1;
        this.tableDataEdit.equipmentId = this.searchDataList.equipmentId;
        file.saveEquipmentDocument(this.tableDataEdit).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.dialogDeviceSpot = false;
            this.tableDataEdit = {
              changeState: 0,
              equipmentId: '',
              fileId: '',
              name: "",
              type: '',
              pid: 0,
              sort: 0,
              status: 0,
            }
            this.fatherMethod('1');
            this.search();
          } else {
            utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
          }
          this.saveLoading = false;
        }).catch((response) => {
          console.log(response)
          this.saveLoading = false;
        })
      } else {
        file.saveEquipmentDocumentEdit(this.tableDataEdit).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.dialogDeviceSpot = false;
            this.tableDataEdit = {
              changeState: 0,
              equipmentId: '',
              fileId: '',
              name: "",
              type: '',
              pid: 0,
              sort: 0,
              status: 0,
            }
            this.fatherMethod('1');
            this.search();
          } else {
            utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
          }
          this.saveLoading = false;
        }).catch((response) => {
          console.log(response)
          this.saveLoading = false;
        })
      }
    },
    deleteDocunment() {
      let param = this.tableDataTreeInfo.id;
      if (Object.keys(this.tableDataTreeInfo).length > 0) {
        this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
          confirmButtonText: this.$t('label_100'),
          cancelButtonText: this.$t('btn_1'),
          type: 'warning'
        }).then(() => {
          file.delEquipmentDocument(param).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.fatherMethod('1');
              this.search();
            } else {
              utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
            }
          }).catch((response) => {
            console.log(response)
          })
        }).catch(() => {

        });
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    changeTime(value) {
      let arr = value;
      if (arr == null || arr == "") {
        return "-";
      } else {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].toString().length == 1) {
            arr[i] = "0" + arr[i];
          }
        }
        if (arr.length == 5) {
          let getFormatTime = arr[0] + "-" + arr[1] + "-" + arr[2] + "\t" + arr[3] + ":" + arr[4] + ":" + "00";
        } else {
          let getFormatTime = arr[0] + "-" + arr[1] + "-" + arr[2] + "\t" + arr[3] + ":" + arr[4] + ":" + arr[5];
        }
        return getFormatTime;
      }
    },
    previewPdf(row) {
      file.selectFileType(row.fileId).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          let type = data.data;
          // if (type.indexOf(".doc") != -1 || type.indexOf(".docx") != -1 || type.indexOf(".xsl") != -1 || type.indexOf(".xslx") != -1 || type.indexOf(".pdf") != -1) {
          if (type.indexOf(".pdf") != -1) {
            this.pdfUrl = row.fileId;
            this.showPdf = true
          } else if (type.indexOf(".jpg") != -1 || type.indexOf(".png") != -1 || type.indexOf(".jpeg") != -1) {
            this.pictureUrl = row.fileId;
            this.showPicture = true
          } else {
            this.$message.error(this.$t('msg_9'))
          }
        } else {
          this.$message.error(this.$t('msg_10'))
        }
      }).catch((response) => {
        console.log(response)
      })

    },
    closePreviewClick() {
      if (this.showPdf == true) {
        this.showPdf = false
      } else if (this.showPicture == true) {
        this.showPicture = false
      }
    },
    deptMes(id) {
      this.deptId = id;
    },
    download() {
      let param = this.tableDataTreeInfo.fileId;
      if (Object.keys(this.tableDataTreeInfo).length > 0) {
        window.location.href = this.$store.getters.getPostUrl +
          'mes/sysFile/download/' + param;
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
  },
  created() {
    this.getCheckList();
    this.MenuRoleList = this.$store.getters.getMenu;
    this.$set(this.monthOptionsObj, this.$t('label_245'), ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']);
    this.$set(this.monthOptionsObj, this.$t('label_242'), ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20']);
    this.$set(this.monthOptionsObj, this.$t('label_238'), ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31']);
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/list/displayPage/electronDocumentParam.vue